import {
  START_LOADING,
  STOP_LOADING,
  RESET_LOADING,
  SHOW_ERROR_MODAL,
  HIDE_ERROR_MODAL
} from "./action";
import { LOG_OUT } from "../login/action";

export const defaultState = {
  loadingCount: 0, // Track the number of loading actions
  error: undefined,
  errorTitle: undefined,
}

function LayoutReducer(state = defaultState, action) {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loadingCount: state.loadingCount + 1
      }
    case STOP_LOADING:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
      }
    case RESET_LOADING:
      return {
        ...state,
        loadingCount: 0,
      }
    case SHOW_ERROR_MODAL:
      return {
        ...state,
        error: action.payload.error,
        errorTitle: action.payload.title,
      }
    case HIDE_ERROR_MODAL:
      return {
        ...state,
        error: undefined,
        errorTitle: undefined,
      }
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default LayoutReducer;